module.exports = __webpack_public_path__ + "2113a0197059591f521bc721787b2437.jpg";


//////////////////
// WEBPACK FOOTER
// ./images/head/AGWESER.jpg
// module id = 879
// module chunks = 0